import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import './activity-calendar.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { IconButton, Button } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
  <Button
    className='py-2 dropdown-button float-right gray-outlined-button'
    variant='outlined'
    size='medium'
    onClick={onClick}
    ref={ref}
    endIcon={<KeyboardArrowDownIcon className='gray-arrow-icon' />}
  >
    {value}
  </Button>
));

const CustomHeader = ({ date, decreaseMonth, increaseMonth, increaseYear, decreaseYear }) => {
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  const year = date.getFullYear();
  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className='d-flex align-items-center'>
        <IconButton onClick={decreaseYear}>
          <KeyboardArrowLeftIcon />
        </IconButton>
        <div>{year}</div>
        <IconButton onClick={increaseYear}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
      <div className='d-flex align-items-center'>
        <IconButton onClick={decreaseMonth}>
          <KeyboardArrowLeftIcon />
        </IconButton>
        <div>{month}</div>
        <IconButton onClick={increaseMonth}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
    </div>
  );
};

const ActivityDatePicker = ({ selectedDate, setSelectedDate }) => {
  const [currentViewDate, setCurrentViewDate] = useState(selectedDate);
  const [isOpen, setIsOpen] = useState(false);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setCurrentViewDate(date);
  };

  const getDayClassNames = (date) => {
    const isCurrentViewMonth =
      date.getMonth() === currentViewDate?.getMonth() &&
      date?.getFullYear() === currentViewDate?.getFullYear();

    if (date.toDateString() === selectedDate?.toDateString()) {
      return 'selected-date';
    }
    if (date.toDateString() === new Date()?.toDateString()) {
      return 'current-date';
    }
    return isCurrentViewMonth ? 'current-month-day' : 'other-month-day';
  };

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat='MMMM yyyy'
        renderCustomHeader={CustomHeader}
        calendarContainer={(props) => <div {...props} className='datePickerSection' />}
        formatWeekDay={(nameOfDay) => nameOfDay?.slice(0, 3).toUpperCase()}
        dayClassName={getDayClassNames}
        showPopperArrow={false}
        onMonthChange={(date) => setCurrentViewDate(date)}
        onYearChange={(date) => setCurrentViewDate(date)}
        customInput={<CustomInput isOpen={isOpen} />}
        onCalendarOpen={() => setIsOpen(true)}
        onCalendarClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default ActivityDatePicker;
